// Mayfair Menagerie: compact drop-down under top menu items that have sub-links.
// Replaces Horizon's full-width mega panel on desktop (see mm-menu-dropdown.css).
(() => {
  if (window.mmMenuDropdown) return;
  window.mmMenuDropdown = true;

  const desktop = window.matchMedia('(min-width: 750px)');
  let openItem = null;
  let openBox = null;
  let hideTimer;

  function buildBox(item) {
    if (item._mmBox) return item._mmBox;
    const submenu = item.querySelector(':scope > .menu-list__submenu');
    if (!submenu) return null;
    const links = submenu.querySelectorAll('a.mega-menu__link');
    if (!links.length) return null;
    const box = document.createElement('div');
    box.className = 'mm-dd';
    box.setAttribute('role', 'menu');
    links.forEach((link) => {
      const a = document.createElement('a');
      a.href = link.getAttribute('href');
      a.textContent = link.textContent.trim();
      a.className = 'mm-dd__link';
      a.setAttribute('role', 'menuitem');
      box.appendChild(a);
    });
    box.addEventListener('pointerenter', () => clearTimeout(hideTimer));
    box.addEventListener('pointerleave', () => scheduleHide());
    box.addEventListener('focusout', (e) => {
      if (!box.contains(e.relatedTarget) && !item.contains(e.relatedTarget)) hide();
    });
    document.body.appendChild(box);
    item._mmBox = box;
    return box;
  }

  function show(item) {
    if (!desktop.matches || item.slot === 'overflow' || item.slot === 'more') return;
    const box = buildBox(item);
    if (!box) return;
    clearTimeout(hideTimer);
    if (openBox && openBox !== box) openBox.classList.remove('mm-dd--open');
    const link = item.querySelector('.menu-list__link') || item;
    const linkRect = link.getBoundingClientRect();
    const header = item.closest('header-component') || item.closest('header');
    const top = header ? header.getBoundingClientRect().bottom : linkRect.bottom;
    box.style.top = `${Math.round(top)}px`;
    box.style.left = `${Math.round(linkRect.left)}px`;
    box.classList.add('mm-dd--open');
    openItem = item;
    openBox = box;
  }

  function hide() {
    clearTimeout(hideTimer);
    if (openBox) openBox.classList.remove('mm-dd--open');
    openItem = null;
    openBox = null;
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 200);
  }

  // Stop Horizon's own mega-menu code from reacting to items we handle. Without this it keeps
  // resizing the (hidden) mega panel and its hover "safety box" as the mouse moves, which shows
  // as a flicker between the header and the page below.
  const blockHorizon = (e) => {
    if (!desktop.matches) return;
    const target = e.target;
    if (!(target instanceof Element)) return;
    const item = target.closest('.menu-list__list-item');
    if (!item || item.slot === 'overflow' || item.slot === 'more') return;
    if (!item.querySelector(':scope > .menu-list__submenu')) return;
    e.stopImmediatePropagation();
  };
  ['pointerenter', 'pointerleave', 'focus', 'blur'].forEach((type) =>
    window.addEventListener(type, blockHorizon, true)
  );

  document.addEventListener('pointerover', (e) => {
    const item = e.target instanceof Element && e.target.closest('.menu-list__list-item');
    if (item && item.querySelector(':scope > .menu-list__submenu')) {
      if (item !== openItem) show(item);
      else clearTimeout(hideTimer);
    }
  });

  document.addEventListener('pointerout', (e) => {
    if (!openItem) return;
    const to = e.relatedTarget;
    if (to instanceof Node && (openItem.contains(to) || openBox.contains(to))) return;
    if (e.target instanceof Node && openItem.contains(e.target)) scheduleHide();
  });

  document.addEventListener('focusin', (e) => {
    const item = e.target instanceof Element && e.target.closest('.menu-list__list-item');
    if (item && item.querySelector(':scope > .menu-list__submenu')) show(item);
    else if (openBox && !(e.target instanceof Node && openBox.contains(e.target))) hide();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openItem) {
      const link = openItem.querySelector('.menu-list__link');
      hide();
      if (link) link.focus();
    }
  });

  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);
})();
